import { injectGlobal } from 'styled-components';

import edenred from './edenred.woff'
import edenred_black from './edenred_black.woff'
import edenred_bold from './edenred_bold.woff'
import edenred_light from './edenred_light.woff'
import edenred_light_italic from './edenred_light_italic.woff'
import edenred_medium from './edenred_medium.woff'
import gothic from './gothic.woff'
import gothic_bold from './gothic_bold.woff'
import gothic_bold_italic from './gothic_bold_italic.woff'
import gothic_italic from './gothic_italic.woff'

injectGlobal`
  @font-face {
    font-family: 'Edenred';
    src: url('${edenred}') format('woff');
  }

  @font-face {
    font-family: 'Edenred Black';
    src: url('${edenred_black}') format('woff');
  }

  @font-face {
    font-family: 'Edenred Bold';
    src: url('${edenred_bold}') format('woff');
  }

  @font-face {
    font-family: 'Edenred Light';
    src: url('${edenred_light}') format('woff');
  }

  @font-face {
    font-family: 'Edenred Light Italic';
    src: url('${edenred_light_italic}') format('woff');
  }

  @font-face {
    font-family: 'Edenred Medium';
    src: url('${edenred_medium}') format('woff');
  }

  @font-face {
    font-family: 'Gothic';
    src: url('${gothic}') format('woff');
  }

  @font-face {
    font-family: 'Gothic Bold';
    src: url('${gothic_bold}') format('woff');
  }

  @font-face {
    font-family: 'Gothic Bold Italic';
    src: url('${gothic_bold_italic}') format('woff');
  }

  @font-face {
    font-family: 'Gothic Italic';
    src: url('${gothic_italic}') format('woff');
  }
`

// const req = require.context('.', true, /\.\/[^/]+\/[^/]+\/\.woff$/);

// req.keys().forEach((key) => {
//     // const componentName = key.replace(/^.+\/([^/]+)\/index\.js/, '$1')
//     // module.exports[componentName] = req(key).default
//     console.log(key);
// })


// WEBPACK FOOTER //
// ./src/assets/fonts/index.js